import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { PartsListComponent } from './components/list/parts-list.component';
import { PartsCustomerSuppliedComponent } from './components/parts-customer-supplied/parts-customer-supplied.component';
import { PartsDetailComponent } from './components/parts-detail/parts-detail.component';
import { PartsLineOfServiceComponent } from './components/parts-line-of-service/parts-line-of-service.component';
import { PartsListResultsComponent } from './components/parts-list-results/parts-list-results.component';
import { PartsSupplierPartsDialogComponent } from './components/parts-supplier-parts/parts-supplier-parts-dialog/parts-supplier-parts-dialog.component';
import { PartsSupplierPartsManageDialogComponent } from './components/parts-supplier-parts/parts-supplier-parts-manage-dialog/parts-supplier-parts-manage-dialog.component';
import { PartsSupplierPartsComponent } from './components/parts-supplier-parts/parts-supplier-parts.component';
import { PartsRoutingModule } from './parts-routing.module';
import { PartsService } from './service/parts.service';

@NgModule({
  imports: [SharedModule, CommonModule, PartsRoutingModule],
  providers: [PartsService],
  declarations: [
    PartsListComponent,
    PartsListResultsComponent,
    PartsDetailComponent,
    PartsLineOfServiceComponent,
    PartsSupplierPartsComponent,
    PartsSupplierPartsDialogComponent,
    PartsSupplierPartsManageDialogComponent,
    PartsCustomerSuppliedComponent
  ],
  entryComponents: [
    PartsSupplierPartsDialogComponent,
    PartsSupplierPartsManageDialogComponent
  ]
})
export class PartsModule {}
